import React from 'react'
import { Route, Link } from 'react-router-dom'
import { connect } from 'react-redux'

// import { userActions } from '../../_actions'

class MemberNavMenu extends React.Component {
  // componentDidMount() {
  //     this.props.dispatch(userActions.getAll())
  // }
  render() {
    const { user } = this.props;
    return (
      <ul className="nav">

        <Route path="/member" exact>
          {({ match }) => <li className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/member"><i className="mdi mdi-home-outline"></i><p>محتوای آموزشی</p></Link></li>}
        </Route>
        {user &&
          <Route path="/member/profile" exact>
            {({ match }) => <li className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/member/profile"><i className="mdi mdi-checkbox-blank-circle-outline mdi-18px"></i><p>اطلاعات شما</p></Link></li>}
          </Route>
        }
        {user &&
          <Route path="/member/exam" exact>
            {({ match }) => <li className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/member/exam"><i className="mdi mdi-checkbox-blank-circle-outline mdi-18px"></i><p>آزمون الکترونیکی</p></Link></li>}
          </Route>
        }
        {user &&
          <Route path="/member/payments" exact>
            {({ match }) => <li className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/member/payments"><i className="mdi mdi-checkbox-blank-circle-outline mdi-18px"></i><p>سوابق پرداخت</p></Link></li>}
          </Route>
        }

      </ul>
    );
  }
}


function mapStateToProps(state) {
  const { authentication } = state;
  const { user } = authentication;
  return {
    user
  };
}

const connectedMemberNavMenu = connect(mapStateToProps)(MemberNavMenu);
export { connectedMemberNavMenu as MemberNavMenu };